{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "virtual": {
    "itemHeight": 112,
    "display": 0
  },
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "Belegdatum",
              "name": "belegdatum",
              "class": "",
              "titleClass": "hidden",
              "filter": true,
              "sortable": true
            },
            {
              "type": "text",
              "title": "",
              "text": "Neu",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "neuerBeleg",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            },
            {
              "type": "text",
              "title": "",
              "text": "Korr. vorhanden",
              "class": "bg-accent rounded-full px-2 ml-2 whitespace-nowrap",
              "visible": {
                "name": "property",
                "property": "belastungVorhanden",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            },
            {
              "type": "text",
              "title": "",
              "text": "Verbucht",
              "class": "bg-success rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "fibudatum",
                "rule": {
                  "name": "not",
                  "rule": {
                    "name": "empty"
                  }
                }
              }
            }
          ]
        },
        {
          "type": "entity",
          "title": "",
          "name": "lieferant",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold",
          "titleClass": "invisible",
          "filter": true,
          "sortable": true
        },
        {
          "type": "string",
          "title": "FremdbelegNr.: ",
          "name": "bezugsnummer",
          "filter": true,
          "sortable": true,
          "class": "whitespace-nowrap"
        },
        {
          "type": "date",
          "title": "Fällig: ",
          "name": "faelligkeitsdatum",
          "filter": true,
          "sortable": true,
          "class": "whitespace-nowrap"
        }
      ]
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "gesamtIncl",
      "codeName": "currency",
      "titleClass": "!text-right",
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamtIncl",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ],
      "filter": true,
      "sortable": true
    }
  ]
}
